<template>
  <authorization permissionKey="attendance_medical_record" can="read">
    <navigation-drawer
      color="white"
      :depth="1"
      permanent
      clipped
      fixed
      class="py-4 text-body-2 font-weight-bold"
    >
      <v-list dense>
        <v-list-item link :to="`/pacientes/${attendance.patient.id}`">
          <v-list-item-content class="gray--text text--lighten-1">
            Histórico
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/geral`">
          <v-list-item-content class="gray--text text--lighten-1">
            Resumo Geral
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/pre-exame`">
          <v-list-item-content class="gray--text text--lighten-1">
            Pré Exame
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/hma`">
          <v-list-item-content class="gray--text text--lighten-1">
            H.M.A
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/hpp`">
          <v-list-item-content class="gray--text text--lighten-1">
            H.P.P
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/hf`">
          <v-list-item-content class="gray--text text--lighten-1">
            H.F
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/prcm`">
          <v-list-item-content class="gray--text text--lighten-1">
            P.R.C.M
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/avrefr`">
          <v-list-item-content class="gray--text text--lighten-1">
            A.V. Refração
          </v-list-item-content>
        </v-list-item>

        <authorization permissionKey="attendance_biomicroscopy" can="read">
        <v-list-item link :to="`/prontuario/${attendance.id}/biomicroscopia`">
          <v-list-item-content class="gray--text text--lighten-1">
            Biomicroscopia
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/biomicroscopia2`">
          <v-list-item-content class="gray--text text--lighten-1">
            Bio Revisão
          </v-list-item-content>
        </v-list-item>
      </authorization>

        <v-list-item link :to="`/prontuario/${attendance.id}/fundoscopia`">
          <v-list-item-content class="gray--text text--lighten-1">
            Fundoscopia
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/fundoscopia2`">
          <v-list-item-content class="gray--text text--lighten-1">
            Fundoscopia Revisão
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/hd`">
          <v-list-item-content class="gray--text text--lighten-1">
            H.D
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="`/prontuario/${attendance.id}/conduta`">
          <v-list-item-content class="gray--text text--lighten-1">
            Conduta
          </v-list-item-content>
        </v-list-item>

         <v-list-item link :to="`/prontuario/${attendance.id}/relatorios`">
          <v-list-item-content class="gray--text text--lighten-1">
            Relatório
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <authorization permissionKey="attendance_exam" can="read">
          <v-list-item link :to="`/prontuario/${attendance.id}/exames`">
            <v-list-item-content class="gray--text text--lighten-1">
              Exames
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="attendance_treatment" can="read">
          <v-list-item link :to="`/prontuario/${attendance.id}/tratamentos`">
            <v-list-item-content class="gray--text text--lighten-1">
              Tratamentos
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="attendance_surgery_indication" can="read">
          <v-list-item link :to="`/prontuario/${attendance.id}/indicacao-cirurgica`">
            <v-list-item-content class="gray--text text--lighten-1">
              Indicações Cirurgicas
            </v-list-item-content>
          </v-list-item>
        </authorization>
      </v-list>
    </navigation-drawer>

    <v-main class="py-0 pt-2" style="padding-left: 180">
      <router-view :attendance="attendance" :attendanceEsigned="attendanceEsigned" />
    </v-main>
  </authorization>
</template>

<script>
  export default {
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
  };
</script>

<style lang="scss" scoped></style>
